
/* eslint-disable prefer-promise-reject-errors */
import {
  defineComponent, nextTick, reactive, ref, toRaw, computed, Ref,
} from 'vue';
import svgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/back.svg';
import '@/assets/icons/close.svg';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import {
  Form, Input, InputNumber, Select, Row, Col, Button, Upload, message, Modal,
} from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import { useForm } from '@ant-design-vue/use';
import commonStore from '@/store/common';
import { RuleObject } from 'ant-design-vue/es/form/interface';
import VueCropper, { VueCropperMethods } from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { useRouter } from 'vue-router';
import asynButtonVue from '@/components/asynButton.vue';
import {
  User, userrule, pass, getUserInfoByCode, changeUserInfo, passrule as passruleLength, changePassword, updateHeadImag,
} from './UserInfo';

interface PassInfo {
  passLevel: Ref<number>;
  passMessage: Ref<string>;
}
const pattern = new RegExp(
  "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]",
);

export default defineComponent({
  components: {
    svgIcon,
    ManagementFrame,
    aForm: Form,
    aFormItem: Form.Item,
    aInput: Input,
    aInputNumber: InputNumber,
    aTextArea: Input.TextArea,
    aPassWord: Input.Password,
    aSelect: Select,
    aSelectOption: Select.Option,
    aRow: Row,
    aCol: Col,
    aButton: asynButtonVue,
    aUpload: Upload,
    PlusOutlined,
    VueCropper,
    aModal: Modal,
  },
  props: {
    valide: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup() {
    const router = useRouter();
    const handleBackClick = () => {
      // emit('close');
      router.back();
    };
    const PassRef = ref();
    const user = new User();
    const userInfo = reactive(user); // 用户信息
    const userForm = reactive(user); // user-form
    const wordForm = reactive(pass); // password-form
    const userRules = reactive(userrule); // user-rules
    const passLevel = computed(() => {
      let num = 0;
      if (!/^[0-9]*$/.test(wordForm.newPassword)) num += 1;
      if (!/^[A-Za-z]*$/.test(wordForm.newPassword)) num += 1;
      if (pattern.test(wordForm.newPassword)) num += 1;
      return num;
    });
    const passMessage = computed(() => ['无', '弱', '中', '强'][passLevel.value]);
    const validatePass = async (rule: RuleObject, value: string) => {
      const num = !/^[0-9]*$/.test(value);
      const str = !/^[A-Za-z]*$/.test(value);
      const sup = pattern.test(value);

      if (value === '') return Promise.reject('请输入新密码');
      if (value.length < 8) return Promise.reject('密码长度不能小于8个字符！');
      if ([num, str, sup].filter((t) => t).length < 2) return Promise.reject('密码组合方式不能小于两种！');
      if (wordForm.conPassword !== '') {
        PassRef.value.validateField('conPassword');
      }
      return Promise.resolve();
    };
    const validatePass2 = async (rule: RuleObject, value: string) => {
      if (value === '') {
        return Promise.reject('请再次输入密码');
      } if (value !== wordForm.newPassword) {
        return Promise.reject('两次密码不一致，请重新输入');
      }
      return Promise.resolve();
    };
    const passrule = reactive({
      oldPassword: [...passruleLength.newPassword],
      newPassword: [...passruleLength.newPassword, { validator: validatePass, trigger: 'change' }],
      conPassword: [...passruleLength.conPassword, { validator: validatePass2, trigger: 'change' }],
    });
    const { validateInfos: userValidateInfos, validate: userValidate } = useForm(userForm, userRules);
    const { validateInfos: passValidateInfos, validate: passValidate } = useForm(wordForm, passrule);
    /** 查询用户信息 */
    const initInfo = async () => {
      const data = await getUserInfoByCode(commonStore.getState().code as string);
      Object.assign(userInfo, data);
      Object.assign(userForm, data);
      commonStore.updateUserInfo({
        ...commonStore.getState(),
        headImagePath: data.headImagePath,
        name: data.name,
      });
    };
    /** 保存信息 */
    const userSubmit = () => {
      userValidate().then(async () => {
        await changeUserInfo({ ...toRaw(userForm) });
        initInfo();
      }).catch((err) => {
        console.log(err);
      });
    };
    /** 修改密码 */
    const passSubmit = () => {
      passValidate().then(async () => {
        changePassword({ ...toRaw(wordForm), code: commonStore.getState().code });
      }).catch((err) => {
        console.log(err);
      });
    };
    /** 图片 */
    const modalVisible = ref(false);
    const imgSrc = ref('');
    const cropper = ref(null);
    const uploadLoading = ref(false);
    // eslint-disable-next-line consistent-return
    const beforeUpload = (file: File) => {
      const arr = ['image/png', 'image/jpeg'];
      if (file.size > 2048000) {
        return message.error('图片大小需在2M内');
      }
      if (!arr.includes(file.type)) {
        return message.error('请上传正确格式图片');
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event: Event) => {
          imgSrc.value = (event.currentTarget as FileReader).result as string;
          modalVisible.value = true;
          nextTick(() => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (cropper.value as any).replace((event.currentTarget as any).result);
          });
        };
        return reader.readAsDataURL(file);
      }
    };
    const onOk = () => {
      console.log('ok');
      return new Promise((resolve, reject) => {
        try {
          uploadLoading.value = true;
          // this.path = (cropper.value as unknown as VueCropperMethods)
          //   .getCroppedCanvas()
          //   .toDataURL();
          (cropper.value as unknown as VueCropperMethods)
            .getCroppedCanvas()
            .toBlob(async (blob: Blob|null) => {
              console.log(blob);
              if (blob) {
                const files = new window.File([blob], '头像.png', {
                  type: 'image/png',
                });
                await updateHeadImag({ code: commonStore.getState().code, file: files });
                initInfo();
                modalVisible.value = false;
                resolve(files);
              } else {
                reject();
              }
            });
        } catch (error) {
          console.error(error);
          reject(error);
        } finally {
          uploadLoading.value = false;
        }
      });
    };
    const onCancel = () => {
      imgSrc.value = '';
      modalVisible.value = false;
      uploadLoading.value = false;
    };
    /** created */
    initInfo();
    return {
      passMessage,
      handleBackClick,
      // 用户
      userInfo,
      userForm,
      userValidateInfos,
      userSubmit,
      // 密码
      wordForm,
      passValidateInfos,
      passSubmit,
      PassRef,
      passrule,
      // Ttuipian
      modalVisible,
      beforeUpload,
      cropper,
      onCancel,
      onOk,
      imgSrc,
      uploadLoading,
    };
  },
});
